<vex-base-layout *ngIf="config$ | async as config">
    <vex-progress-bar></vex-progress-bar>

    <vex-search></vex-search>

    <mat-sidenav-container class="vex-layout-sidenav-container">
        <mat-sidenav (closedStart)="onSidenavClosed()" [disableClose]="!!(sidenavDisableClose$ | async)"
            [fixedInViewport]="!!(sidenavFixedInViewport$ | async)" [mode]="(sidenavMode$ | async) ?? 'side'"
            [opened]="!!(sidenavOpen$ | async)">
            <vex-sidenav [collapsed]="!!(sidenavCollapsed$ | async)"></vex-sidenav>
        </mat-sidenav>

        <mat-sidenav (closedStart)="onQuickpanelClosed()" [opened]="!!(quickpanelOpen$ | async)"
            class="vex-layout-quickpanel" mode="over" position="end">
            <vex-quickpanel></vex-quickpanel>
        </mat-sidenav>

        <mat-sidenav-content class="vex-layout-sidenav-content">
            <vex-toolbar class="vex-toolbar"></vex-toolbar>

            <main class="vex-layout-content">
                <router-outlet></router-outlet>
            </main>

            <div class="w-full h-[4px] bg-gradient-to-r from-[#F4A300] via-[#E63E11] to-[#C8102E]"></div>
            <!-- FOOTER -->
            <footer class="border-t border-gray-200 footer-container py-10">

                <div class="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">

                    <!-- LEFT: LOGO -->
                    <div class="flex flex-col items-center text-center">
                        <img src="assets/img/logo/logo.png" alt="VIJP Logo"
                            class="w-52 md:w-60 mb-3 object-contain transition-transform duration-300 hover:scale-105" />

                        <p class="text-red-700 text-xl font-medium leading-relaxed">
                            日本信発国際株式会社 <br>
                            TINPHAT GROUP 日本支社
                        </p>
                    </div>


                    <!-- RIGHT: CONTACT INFO -->
                    <div class="text-red-700 text-sm md:text-base space-y-3">
                        <h3 class="text-red-700 text-lg font-semibold mb-3 flex items-start gap-2">
                            <mat-icon svgIcon="mat:contact_mail" class="text-[#F4A300] mt-1"></mat-icon>
                            <span class="leading-tight">
                                連絡先<br>
                                <span class="text-sm text-red-700/80">Contact Information</span>
                            </span>
                        </h3>


                        <!-- JAPAN OFFICE -->
                        <div class="space-y-1">
                            <div class="flex items-center gap-2 font-semibold">
                                <mat-icon svgIcon="flag:japan" class="text-[#F4A300]"></mat-icon>
                                Japan Office
                            </div>
                            <div class="pl-7 space-y-1">
                                <div class="flex items-center gap-2">
                                    <mat-icon svgIcon="mat:location_on" class="text-red-700"></mat-icon>
                                    <span>〒116-0013　東京都荒川区西日暮里５－２－１９　リレント第２西日暮里２F</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <mat-icon svgIcon="mat:phone" class="text-red-700"></mat-icon>
                                    <span>TEL: 03-5850-5775</span>
                                    <span>FAX: 03-5850-5776</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <mat-icon svgIcon="mat:mail" class="text-red-700"></mat-icon>
                                    <span>info&#64;vijp.jp</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"
                                        class="w-5 h-5 fill-red-700 opacity-90">
                                        <path d="M240 363.3L240 576L356 576L356 363.3L442.5 363.3L460.5 265.5L356 265.5L356 230.9C356 179.2 
        376.3 159.4 428.7 159.4C445 159.4 458.1 159.8 465.7 160.6L465.7 71.9C451.4 68 416.4 64 396.2 64
        C289.3 64 240 114.5 240 223.4L240 265.5L174 265.5L174 363.3L240 363.3z" />
                                    </svg>

                                    <a href="https://www.facebook.com/TinPhatNhatBan.VIJP?mibextid=wwXIfr&rdid=wcvRftd9YYXj958x#"
                                        target="_blank" class="hover:text-[#F4A300] transition">
                                        &nbsp;https://www.facebook.com/TinPhatNhatBan.VIJP
                                    </a>
                                </div>

                            </div>
                        </div>

                        <!-- VIETNAM OFFICE -->
                        <!-- <div class="space-y-1 pt-2">
                            <div class="flex items-center gap-2 font-semibold">
                                <mat-icon svgIcon="flag:vietnam" class="text-[#F4A300]"></mat-icon>
                                Vietnam Office
                            </div>
                            <div class="pl-7 space-y-1">
                                <div class="flex items-center gap-2">
                                    <mat-icon svgIcon="mat:location_on" class="text-red-700"></mat-icon>
                                    <span>Tòa nhà Tín Phát, Quận 1, TP. Hồ Chí Minh</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <mat-icon svgIcon="mat:phone" class="text-red-700"></mat-icon>
                                    <span>+84-28-1234-5678</span>
                                </div>
                                <div class="flex items-center gap-2">
                                    <mat-icon svgIcon="mat:chat" class="text-red-700"></mat-icon>
                                    <span>Zalo・LINE対応</span>
                                </div>
                            </div>
                        </div> -->

                        <!-- GOOGLE MAP -->
                        <div class="mt-4 rounded-xl overflow-hidden shadow-md border border-[#C8102E]/20"
                            data-aos="fade-up" data-aos-delay="400">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.649446431!2d139.7725309155369!3d35.74352728019379!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188d9902e32797%3A0xa09d7dd350db8bef!2z44CSMTE2LTAwMTMg5p2x5Lqs6YO_44GV44Gn44K_44GX5a6u5b2x5paH5bed5Yy654mH44Oe!5e0!3m2!1sja!2sjp!4v1700748512345!5m2!1sja!2sjp"
                                width="100%" height="200" style="border:0;" allowfullscreen="" loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade">
                            </iframe>

                        </div>

                        <!-- LINKS -->
                        <div class="flex flex-wrap gap-4 pt-4">
                            <a (click)="scrollToHome()" class="hover:underline hover:cursor-pointer hover:text-blue-700 text-red-700">Home</a>
                            <a (click)="scrollToAbout()" class="hover:underline hover:cursor-pointer hover:text-blue-700 text-red-700">About</a>
                            <a (click)="scrollToServices()" class="hover:underline hover:cursor-pointer hover:text-blue-700 text-red-700">Services</a>
                            <!-- <a routerLink="/news" class="hover:underline text-red-700">News</a> -->
                            <a (click)="scrollToContact()" class="hover:underline hover:cursor-pointer hover:text-blue-700 text-red-700 ">Contact</a>
                        </div>

                        <p class="pt-4 text-xs text-red-700/80">
                            © 2025 VIJP – All rights reserved. | Designed by VIJP Co., Ltd.
                        </p>
                    </div>
                </div>
            </footer>







        </mat-sidenav-content>


    </mat-sidenav-container>

    <vex-config-panel-toggle (openConfig)="configpanel.open()"></vex-config-panel-toggle>

    <!-- CONFIGPANEL -->
    <vex-sidebar #configpanel [invisibleBackdrop]="true" [opened]="!!(configPanelOpen$ | async)" position="right">
        <vex-config-panel></vex-config-panel>
    </vex-sidebar>
    <!-- END CONFIGPANEL -->
</vex-base-layout>